import type React from 'react';
import { Navbar, Footer, PricingTable } from '@shadeables/ui';

const Pricing: React.FC = () => {
  return (
    <div>
      <Navbar />
      <PricingTable />
      <Footer />
    </div>
  );
};

export default Pricing;
